import { createSlice, PayloadAction } from "@reduxjs/toolkit";
//import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
interface NavbarState {
  title: string;
}

const initialState: NavbarState = {
  title: "Dashboard",
};
// Map routes to Navbar titles
export const routeTitles: Record<string, string> = {
  "/dashboard": "Dashboard",
  "/products": "Products",
  "/redux": "Redux EX",
  "/category":"Category",
  "/products/addproduct":"Products > Add Product",
  "/categories":"Categories",
  "/attributes":"Attributes",
  "/books":"Books",
  "/food_beverage":"Food Beverage",
  "/stores":"Stores",
  "/stores/addstore":`Stores / Add Store`,
  "/stores/editstore":`Stores / Edit Store`,
  
};
const navbarSlice = createSlice({
  name: "navbar",
  initialState,
  reducers: {
    setNavbarTitle: (state, action: PayloadAction<string>) => {
      state.title = action.payload;
    },
  },
});

export const { setNavbarTitle } = navbarSlice.actions;
export default navbarSlice.reducer;
